const initFeedbackModal = (root = document) => {
  const dialog = root.querySelector('[data-feedback-modal]');
  if (!dialog || dialog.dataset.feedbackInit === 'true') return;
  dialog.dataset.feedbackInit = 'true';

  const open = () => {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  };

  const close = () => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  };

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  const closeButton = dialog.querySelector('[data-feedback-close]');
  closeButton?.addEventListener('click', close);

  // Reações (emojis)
  const reactionGroup = dialog.querySelector('[data-reaction-group]');
  const reactionOutput = dialog.querySelector('[data-reaction-output]');
  const reactions = reactionGroup ? reactionGroup.querySelectorAll('[data-reaction-value]') : [];

  const setSelectedReaction = (button) => {
    reactions.forEach((item) => {
      const isSelected = item === button;
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (reactionOutput instanceof HTMLInputElement) {
      reactionOutput.value = button.dataset.reactionValue || '';
    }
  };

  reactions.forEach((button) => {
    button.addEventListener('click', () => setSelectedReaction(button));
  });

  // Upload de imagem
  const uploader = dialog.querySelector('[data-uploader]');
  const uploaderInput = dialog.querySelector('[data-uploader-input]');
  const uploaderTrigger = dialog.querySelector('[data-uploader-trigger]');
  const uploaderPreview = dialog.querySelector('[data-uploader-preview]');

  const updateUploaderPreview = () => {
    if (!(uploaderInput instanceof HTMLInputElement) || !(uploaderPreview instanceof HTMLElement)) return;

    const fileCount = uploaderInput.files ? uploaderInput.files.length : 0;

    if (fileCount === 0) {
      uploaderPreview.textContent = '';
      return;
    }

    if (fileCount === 1) {
      uploaderPreview.textContent = uploaderInput.files[0].name;
      return;
    }

    uploaderPreview.textContent = fileCount + ' arquivos';
  };

  if (uploader && uploaderInput && uploaderTrigger) {
    uploaderTrigger.addEventListener('click', () => {
      if (uploaderInput instanceof HTMLInputElement) uploaderInput.click();
    });

    uploaderInput.addEventListener('change', updateUploaderPreview);
  }

  // Contato condicional
  const contactChoices = dialog.querySelectorAll('[data-contact-choice]');
  const conditionalGroup = dialog.querySelector('[data-conditional-group]');

  const setConditionalVisibility = (shouldShow) => {
    if (!(conditionalGroup instanceof HTMLElement)) return;

    conditionalGroup.classList.toggle('is-visible', shouldShow);
    conditionalGroup.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

    var conditionalInputs = conditionalGroup.querySelectorAll('input');
    conditionalInputs.forEach((input) => {
      if (input instanceof HTMLInputElement) {
        if (shouldShow) {
          input.setAttribute('required', '');
        } else {
          input.removeAttribute('required');
          input.value = '';
        }
      }
    });
  };

  contactChoices.forEach((choice) => {
    choice.addEventListener('change', () => {
      var shouldShow = choice instanceof HTMLInputElement && choice.value === 'yes' && choice.checked;
      setConditionalVisibility(shouldShow);
    });
  });

  // Máscara de telefone (XX) XXXXX-XXXX
  var phoneInput = conditionalGroup ? conditionalGroup.querySelector('input[type="tel"]') : null;
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      var v = this.value.replace(/\D/g, '').slice(0, 11);
      if (v.length > 6) {
        this.value = '(' + v.slice(0, 2) + ') ' + v.slice(2, 7) + '-' + v.slice(7);
      } else if (v.length > 2) {
        this.value = '(' + v.slice(0, 2) + ') ' + v.slice(2);
      } else if (v.length > 0) {
        this.value = '(' + v;
      }
    });
  }

  // Erro
  var errorContainer = dialog.querySelector('[data-feedback-error]');

  var setError = (message) => {
    if (!(errorContainer instanceof HTMLElement)) return;
    errorContainer.textContent = message || '';
  };

  var getContactChoice = () => {
    var contactYes = dialog.querySelector('[data-contact-choice="yes"]');
    var contactNo = dialog.querySelector('[data-contact-choice="no"]');
    if (contactYes instanceof HTMLInputElement && contactYes.checked) return 'yes';
    if (contactNo instanceof HTMLInputElement && contactNo.checked) return 'no';
    return '';
  };

  // Validação
  var validate = () => {
    if (reactionOutput instanceof HTMLInputElement && reactionOutput.value === '') {
      return 'Selecione uma reação.';
    }

    var messageField = dialog.querySelector('textarea');
    if (messageField instanceof HTMLTextAreaElement && messageField.value.trim() === '') {
      return 'Descreva sua experiência.';
    }

    if (getContactChoice() === '') {
      return 'Escolha se deseja contato.';
    }

    if (conditionalGroup instanceof HTMLElement && conditionalGroup.classList.contains('is-visible')) {
      var nameField = conditionalGroup.querySelector('input[type="text"]');
      if (nameField instanceof HTMLInputElement && nameField.value.trim() === '') {
        return 'Preencha o nome.';
      }

      var phoneField = conditionalGroup.querySelector('input[type="tel"]');
      if (phoneField instanceof HTMLInputElement && phoneField.value.replace(/\D/g, '').length < 10) {
        return 'Preencha um telefone válido.';
      }
    }

    return '';
  };

  // Submit → Google Sheets via App Proxy
  var formEl = dialog.querySelector('[data-feedback-form]');
  var submitBtn = dialog.querySelector('[data-feedback-submit]');

  if (submitBtn && formEl) {
    submitBtn.addEventListener('click', async (event) => {
      event.preventDefault();

      var errorMessage = validate();
      setError(errorMessage);
      if (errorMessage) return;

      // Desabilita botão durante envio
      submitBtn.disabled = true;
      submitBtn.textContent = 'Enviando...';

      var params = new URLSearchParams(window.location.search);
      var contactChoice = getContactChoice();
      var nome = '';
      var telefone = '';

      if (contactChoice === 'yes' && conditionalGroup) {
        var nameField = conditionalGroup.querySelector('input[type="text"]');
        var phoneField = conditionalGroup.querySelector('input[type="tel"]');
        nome = nameField ? nameField.value.trim() : '';
        telefone = phoneField ? phoneField.value.trim() : '';
      }

      var mensagem = (dialog.querySelector('textarea') || {}).value || '';
      var reacao = reactionOutput instanceof HTMLInputElement ? reactionOutput.value : '';

      // Monta FormData (para suportar upload de imagem)
      var formData = new FormData();
      formData.append('nome', nome);
      formData.append('email', '');
      formData.append('telefone', telefone);
      formData.append('mensagem', mensagem.trim());
      formData.append('reacao', reacao);
      formData.append('quer_contato', contactChoice === 'yes' ? 'Sim' : 'Não');
      formData.append('origem', 'feedback');
      formData.append('page_url', window.location.href);
      formData.append('utm_source', params.get('utm_source') || '');
      formData.append('utm_medium', params.get('utm_medium') || '');
      formData.append('utm_campaign', params.get('utm_campaign') || '');
      formData.append('utm_term', params.get('utm_term') || '');
      formData.append('utm_content', params.get('utm_content') || '');

      // Anexa imagens se houver
      if (uploaderInput instanceof HTMLInputElement && uploaderInput.files) {
        for (var i = 0; i < uploaderInput.files.length; i++) {
          formData.append('files', uploaderInput.files[i]);
        }
      }

      try {
        var res = await fetch('/apps/hub-proxy/api/form-submit', {
          method: 'POST',
          body: formData,
        });
        var json = await res.json();

        if (json.success) {
          close();
          alert('Feedback enviado com sucesso! Obrigado.');
        } else {
          setError(json.error || 'Erro ao enviar. Tente novamente.');
        }
      } catch (err) {
        setError('Erro de conexão. Tente novamente.');
      }

      submitBtn.disabled = false;
      submitBtn.textContent = 'Enviar';
    });
  }

  window.openFeedbackModal = open;
  window.closeFeedbackModal = close;
  window.getFeedbackReaction = () => (reactionOutput instanceof HTMLInputElement ? reactionOutput.value : '');
  window.getFeedbackUploads = () =>
    uploaderInput instanceof HTMLInputElement && uploaderInput.files ? Array.from(uploaderInput.files) : [];
};

document.addEventListener('DOMContentLoaded', () => initFeedbackModal());
document.addEventListener('shopify:section:load', (event) => initFeedbackModal(event.target));
